import 'css-chunksrc/client/scenes/unavailabilityEdition/styles.scss';export default {
  "unavailabilityEdition": "_unavailabilityEdition_12jz4_1",
  "title": "_title_12jz4_9",
  "main": "_main_12jz4_15",
  "buttons": "_buttons_12jz4_28",
  "header": "_header_12jz4_37",
  "contextualMenu": "_contextualMenu_12jz4_43",
  "removeIcon": "_removeIcon_12jz4_47"
};